"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppContext = exports.AppContext = exports.ERROR_CODE = void 0;
const react_1 = require("react");
require("rxjs");
require("../baseTypes");
require("../request/types");
var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE["AccessDenied"] = "AccessDenied";
    ERROR_CODE["ExpiredToken"] = "ExpiredToken";
    ERROR_CODE["InvalidToken"] = "InvalidToken";
    ERROR_CODE["InvalidURI"] = "InvalidURI";
    ERROR_CODE["MethodNotAllowed"] = "MethodNotAllowed";
    ERROR_CODE["NotFound"] = "NotFound";
    ERROR_CODE["NotImplemented"] = "NotImplemented";
    ERROR_CODE["ServiceUnavailable"] = "ServiceUnavailable";
    ERROR_CODE["UnexpectedContent"] = "UnexpectedContent";
    ERROR_CODE["UnknownError"] = "UnknownError";
})(ERROR_CODE = exports.ERROR_CODE || (exports.ERROR_CODE = {}));
const appContextNoop = () => {
    throw new Error('AppContext error: you must provide AppContext');
};
exports.AppContext = react_1.createContext({
    getToken: appContextNoop,
    getApiRequest: appContextNoop,
    getErrorListener: appContextNoop,
    getErrorStream: appContextNoop,
    getConfig: appContextNoop,
});
const useAppContext = () => react_1.useContext(exports.AppContext);
exports.useAppContext = useAppContext;
//# sourceMappingURL=AppContext.js.map